import * as Yup from "yup";

import { variables } from "../Variables";

const { required, IsEmail, password_match } = variables;

export const createUserInAdmin = Yup.object({
  first_name: Yup.string().required(required),
  last_name: Yup.string().required(required),
  email: Yup.string().required(required).email(IsEmail),
});

export const updateUserInAdmin = Yup.object({
  id: Yup.string().required(required),
  first_name: Yup.string().required(required),
  last_name: Yup.string().required(required),
  email: Yup.string().required(required).email(IsEmail),
});
